var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box_left" }, [
    _c(
      "div",
      {
        staticStyle: { display: "flex", position: "relative", height: "100%" },
      },
      [
        _c(
          "div",
          { staticClass: "item_box" },
          _vm._l(_vm.leftList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "item",
                  _vm.selectItem.name == item.name ? "actives" : "",
                ],
                on: {
                  mouseover: function ($event) {
                    return _vm.selectPage(item)
                  },
                  click: function ($event) {
                    return _vm.selectFirst(item)
                  },
                },
              },
              [
                _c("i", { class: ["iconfont", "icon-" + item.icon] }),
                _vm._v(" "),
                _c("div", { staticClass: "leftTitle" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }